import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend,
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { TrendingUp } from 'lucide-react';

const AXIS_TICK = { fontSize: 11 };
const TOOLTIP_CONTENT_STYLE = { background: '#0f172a', border: '1px solid #334155', borderRadius: 6 };
const TOOLTIP_LABEL_STYLE = { color: '#cbd5e1' };
const TOOLTIP_ITEM_STYLE = { color: '#fff' };
const LEGEND_STYLE = { color: '#cbd5e1', fontSize: 12 };
const BAR_RADIUS = [2, 2, 0, 0];
const CHART_CONTAINER_STYLE = { minHeight: 260 };

const usd = (n) => `$${(Number(n) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
const fmtMonth = (m) => {
  try { return new Date(m + '-01T00:00:00').toLocaleDateString(undefined, { month: 'short', year: '2-digit' }); }
  catch { return m; }
};

/**
 * Monthly income vs expenses bar chart. `timeline` items: { month, income, expenses }.
 */
const LedgerChart = ({ timeline }) => (
  <Card className="bg-slate-900 border-slate-800 lg:col-span-2">
    <CardHeader className="pb-3">
      <CardTitle className="text-base text-white flex items-center gap-2">
        <TrendingUp className="w-4 h-4 text-green-400" /> Monthly income vs expenses
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="w-full min-w-0 h-[260px]" style={CHART_CONTAINER_STYLE} data-testid="ledger-chart">
        <ResponsiveContainer width="100%" height={260} debounce={100}>
          <BarChart data={timeline.map((d) => ({ ...d, label: fmtMonth(d.month) }))}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1e293b" />
            <XAxis dataKey="label" stroke="#64748b" tick={AXIS_TICK} interval="preserveStartEnd" />
            <YAxis stroke="#64748b" tick={AXIS_TICK} />
            <Tooltip
              contentStyle={TOOLTIP_CONTENT_STYLE}
              labelStyle={TOOLTIP_LABEL_STYLE}
              itemStyle={TOOLTIP_ITEM_STYLE}
              formatter={(v) => usd(v)}
            />
            <Legend wrapperStyle={LEGEND_STYLE} />
            <Bar dataKey="income" name="Income" fill="#22c55e" radius={BAR_RADIUS} />
            <Bar dataKey="expenses" name="Expenses" fill="#ef4444" radius={BAR_RADIUS} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </CardContent>
  </Card>
);

export default LedgerChart;
